export enum FaqItemSort {
  Group = 1,
  Question = 2,
  Status = 3,
}
